import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

import { SharedModule } from '../../../shared/shared.module';
import { InViewPortDirective } from '../../../shared/directives/in-view-port.directive';

@Component({
  selector: 'app-hero-section',
  templateUrl: './hero-section.component.html',
  styleUrl: './hero-section.component.scss',
  standalone: true,
  imports: [SharedModule, InViewPortDirective, MatIconModule],
})
export class HeroSectionComponent {
  constructor(private readonly router: Router) {}

  goTo(path: string) {
    this.router.navigate([path]);
  }

  isVisible(_event: any) {}
}
